<div class="container-fluid">

    <Chathomeemer *ngIf="chatUrl" [chatUrl]="chatUrl">
    </Chathomeemer>


</div>
